interface IAppConfig {
    packageDetailApiBaseUrl: string;
    medicineImageApiBaseUrl: string;
    clientLogApiBaseUrl: string;
    faqPageUrl: string;
    tosPageUrl: string;
    licensePageUrl: string;
    demoDataSerialCode: string;
    latestNoticeId: string;
    noticePageUrl: string;
}

export class AppConfig {
    public odpInfoApiUrl: string = '';
    public medicineImageApiUrl: string = '';
    public clientLogApiUrl: string = '';
    public faqPageUrl: string = '';
    public tosPageUrl: string = '';
    public licensePageUrl: string = '';
    public demoDataSerialCode: string = '';
    public latestNoticeId: string = '';
    public noticePageUrl: string = '';

    public async init() {
        return fetch('appconfig')
            .then((response) => response.json() as Promise<IAppConfig>)
            .then((data) => {
                this.odpInfoApiUrl = data.packageDetailApiBaseUrl;
                this.medicineImageApiUrl = data.medicineImageApiBaseUrl;
                this.clientLogApiUrl = data.clientLogApiBaseUrl;
                this.faqPageUrl = data.faqPageUrl;
                this.tosPageUrl = data.tosPageUrl;
                this.licensePageUrl = data.licensePageUrl;
                this.demoDataSerialCode = data.demoDataSerialCode;
                this.latestNoticeId = data.latestNoticeId;
                this.noticePageUrl = data.noticePageUrl;
            });
    }
}

const appConfig = new AppConfig();
export default appConfig;
